document.addEventListener('DOMContentLoaded',function(){
    if(document.querySelectorAll('[JSAddToCart]').length > 0){
        document.querySelectorAll('[JSAddToCart]').forEach(function(add){
            add.addEventListener('click',function(e){
                e.preventDefault();
                console.log(this.dataset.id)
                let formData = {
                    'items': [{
                    'id': this.dataset.id,
                    'quantity': 1
                    }]
                };
                fetch(window.Shopify.routes.root + "cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(formData),
                })
                .then((response) => {
                    return response.json();
                })
                .finally(() => {
                    document.querySelector("#CartButton").click();
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
            })
        })
    }

    if(document.querySelectorAll('[JSScrollTabHandle]').length > 0){
        document.querySelectorAll('[JSScrollTabHandle]').forEach(function(tab){
            tab.addEventListener('click',function(e){
                e.preventDefault();
                var data_id = this.getAttribute('href');
                document.querySelectorAll('[JSScrollTabHandle]').forEach(function(event){
                    event.parentNode.classList.remove('active');
                })
                this.parentNode.classList.add('active');
                if(document.querySelector(data_id)){
                    document.querySelectorAll('.collection_wrpr').forEach(function(event){
                        event.classList.remove('active');
                    })
                    document.querySelector(data_id).classList.add('active');
                }
            })
        })
    }
})